/**
 * "Continue with SkSnap" from the SkSnap Market lands on /market/continue. If the person is not signed in yet they go
 * through the normal /auth page, and this remembers - for a few minutes, in this tab only - that they should come back
 * to that one page afterwards instead of the usual landing page.
 *
 * Deliberately NOT an arbitrary "?next=" redirect: only the single path below is ever remembered or returned, so this can
 * never be used as an open redirect.
 */
const KEY = "sksnap.postLoginReturn";
export const MARKET_CONTINUE_PATH = "/market/continue";
const TTL_MS = 10 * 60 * 1000;

export function rememberMarketReturn(): void {
  try {
    sessionStorage.setItem(KEY, JSON.stringify({ path: MARKET_CONTINUE_PATH, at: Date.now() }));
  } catch {
    /* storage blocked: the person just lands on the normal page after signing in and can click the Market link again */
  }
}

/** The remembered path, or null. Does not clear it (several components may ask while one login finishes). */
export function peekPostLoginPath(): string | null {
  try {
    const raw = sessionStorage.getItem(KEY);
    if (!raw) return null;
    const v = JSON.parse(raw) as { path?: unknown; at?: unknown };
    if (v.path !== MARKET_CONTINUE_PATH || typeof v.at !== "number") return null;
    if (Date.now() - v.at > TTL_MS || v.at > Date.now() + 60_000) return null;
    return MARKET_CONTINUE_PATH;
  } catch {
    return null;
  }
}

export function clearPostLoginPath(): void {
  try {
    sessionStorage.removeItem(KEY);
  } catch {
    /* ignore */
  }
}

/** Where to go after a successful sign-in. */
export function postLoginPath(fallback = "/chat"): string {
  return peekPostLoginPath() ?? fallback;
}
